<template>
  <div class="p-box">
    <div class="p-box__body">
      <div v-if="!loading && payment_histories">
        <div class="c-grid">
          <h2 class="c-pageTitle">{{ $t('pages.companies.paymentSetting.paymentHistory.title') }}</h2>
        </div>
        <div class="c-info">
          <div class="c-info__icon"><Icon name="iconQuestion" /></div>
          <div class="c-info__content">
            <p>{{ $t('pages.companies.paymentSetting.paymentHistory.info') }}</p>
          </div>
        </div>
        <div class="p-table">
          <div class="p-table__content">
            <table>
              <thead>
                <tr>
                  <th>{{ $t('pages.companies.paymentSetting.paymentHistory.date') }}</th>
                  <th>{{ $t('pages.companies.paymentSetting.paymentHistory.detail') }}</th>
                  <th>{{ $t('pages.companies.paymentSetting.paymentHistory.amount') }}</th>
                </tr>
                <tr class="p-table__content__space">
                  <td colspan="5" />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(payment_history, i) in payment_histories.data"
                  :key="i"
                >
                  <td>{{ displayPaymentAt(payment_history.attributes.created_at) }}</td>
                  <td v-text="payment_history.attributes.details" />
                  <td v-text="$t('labels.currency.yen', { number: Number(payment_history.attributes.amount).toLocaleString() })" />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Loading v-show="loading" />
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Loading from '../Loading'
import Icon from '../Icon'
import moment from 'moment'

export default {
  name: 'PaymentHistory',
  components: {
    Loading,
    Icon,
  },
  computed: {
    ...mapState({
      payment_histories: state => state.companiesPaymentHistories.data,
      loading: state => state.companiesPaymentHistories.loading,
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
  },
  created() {
    this.readPaymentHistories(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      readPaymentHistories: 'companiesPaymentHistories/readPaymentHistories',
    }),
    displayPaymentAt(payment_at) {
      return moment(new Date(payment_at)).format(this.$t('format.date.default'))
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
